module.exports = __webpack_public_path__ + "img/plus-new.344db81e.svg";